import { Component, Input, ViewEncapsulation } from '@angular/core';
import { PaymentMethodModel } from '../../shared/models/payment-method.model';
import { PaymentCardModel } from '../../shared/models/payment/order/payment-card.model';

@Component({
    selector: 'completed-payment-method',
    templateUrl: './completed.payment-method.component.html',
    styleUrls: ['./../completed.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CompletedPaymentMethodComponent {
    @Input('paymentMethod') paymentMethod: PaymentMethodModel;
    @Input('isHugeOrder') isHugeOrder: boolean;
    @Input('isBankSlip') isBankSlip: boolean;
    @Input('isPix') isPix: boolean;
    @Input('bankSlipUrl') bankSlipUrl: string;
    @Input('paymentCode') paymentCode: string;
    @Input('paymentCodeQr') paymentCodeQr: string;
    @Input('paymentCard') paymentCard: PaymentCardModel;
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/completed/payment-method/completed.payment-method.component.ts